import { configureStore } from '@reduxjs/toolkit';

import { customerApi } from './customersApi';
import { deviceApi } from './devicesApi';
import { productsApi } from './productsApi';
import { subscriptionsApi } from './subscriptionsApi';
import { chargesApi } from './chargesApi';
import { paymentsApi } from './paymentsApi';
import { addressesApi } from './addressesApi';
import { ordersApi } from './ordersApi';
import { returnOrdersApi } from './returnOrdersApi';
import { returnLabelsApi } from './returnLabelsApi';
import rootReducer from './reducers';

export function configureAppStore(preloadedState) {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(
        customerApi.middleware,
        subscriptionsApi.middleware,
        deviceApi.middleware,
        productsApi.middleware,
        chargesApi.middleware,
        paymentsApi.middleware,
        addressesApi.middleware,
        ordersApi.middleware,
        returnOrdersApi.middleware,
        returnOrdersApi.middleware,
        returnLabelsApi.middleware,
      ),
    preloadedState,
  });

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
  }

  return store;
}

const store = configureAppStore();

export default store;
